import React from 'react';

export const OutlookMailIconBorderless = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M14.2971 1H5.70166C5.31657 1 4.99969 1.31687 4.99969 1.70196V2.49985L9.84435 3.99985L14.999 2.49985V1.70196C14.999 1.31687 14.6822 1 14.2971 1Z"
			fill="#0364B8"
		/>
		<path
			d="M15.824 8.70203C15.8972 8.47184 15.9557 8.23723 15.9989 7.99955C15.999 7.88064 15.9354 7.77046 15.8325 7.71104L15.826 7.70755L15.824 7.70661L10.4053 4.61977C10.3819 4.60464 10.3577 4.59075 10.3328 4.57824C10.123 4.47424 9.87617 4.47424 9.66635 4.57824C9.64148 4.59075 9.61726 4.60457 9.59384 4.61977L4.17523 7.70661L4.17319 7.70755L4.16664 7.71104C4.06374 7.77046 4.00017 7.88064 4.00024 7.99955C4.04352 8.23723 4.10199 8.47184 4.17523 8.70203L9.92083 12.9042L15.824 8.70203Z"
			fill="#0A2767"
		/>
		<path
			d="M11.9993 2.49982H8.49949L7.48901 3.99982L8.49949 5.49967L11.9993 8.49945H14.9991V5.49967L11.9993 2.49982Z"
			fill="#28A8EA"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.99969 2.49982H8.49948V5.4996H4.99969V2.49982Z"
			fill="#0078D4"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9993 2.49982H14.9991V5.4996H11.9993V2.49982Z"
			fill="#50D9FF"
		/>
		<path
			d="M11.9993 8.49948L8.49948 5.49969H4.99969V8.49948L8.49948 11.4993L13.9151 12.3833L11.9993 8.49948Z"
			fill="#0364B8"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.49951 5.49969H11.9993V8.49948H8.49951V5.49969Z"
			fill="#0078D4"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.99969 8.49951H8.49948V11.4993H4.99969V8.49951Z"
			fill="#064A8C"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9993 8.49951H14.9991V11.4993H11.9993V8.49951Z"
			fill="#0078D4"
		/>
		<path
			d="M10.0949 12.6083L4.19824 8.30859L4.44522 7.87411C4.44522 7.87411 9.81737 10.9339 9.89933 10.9799C9.96726 11.0072 10.0436 11.005 10.1099 10.9739C10.1863 10.9309 15.5755 7.85913 15.5755 7.85913L15.8235 8.2936L10.0949 12.6083Z"
			fill="#0A2767"
			fillOpacity="0.498039"
		/>
		<path
			d="M15.8325 8.28813L15.826 8.29213L15.8245 8.29315L10.4059 11.38C10.1872 11.5209 9.9103 11.5382 9.6759 11.4254L11.5632 13.9558L15.69 14.8542V14.8563C15.8846 14.7156 16 14.4894 16 14.2493V7.99969C16 8.11853 15.9364 8.22879 15.8335 8.28813H15.8325Z"
			fill="#1490DF"
		/>
		<path
			d="M15.999 14.2492V13.8803L11.0078 11.0364L10.4053 11.3794C10.1868 11.5204 9.90982 11.5377 9.67542 11.4249L11.5628 13.9553L15.6895 14.8537V14.8557C15.8841 14.7149 15.9995 14.4889 15.9995 14.2487L15.999 14.2492Z"
			fill="black"
			fillOpacity="0.047059"
		/>
		<path
			d="M15.974 14.4407L10.5028 11.3239L10.4053 11.3794C10.1868 11.5203 9.90982 11.5377 9.67542 11.4249L11.5628 13.9553L15.6895 14.8537V14.8557C15.8295 14.7542 15.9303 14.6073 15.9745 14.4402L15.974 14.4407Z"
			fill="black"
			fillOpacity="0.098039"
		/>
		<path
			d="M4.17469 8.29468V8.28966H4.16974L4.15469 8.2797C4.05767 8.21999 3.99876 8.11359 3.99971 7.99969V14.2503C3.99971 14.6612 4.33781 14.9993 4.74872 14.9993H15.2491C15.3115 14.9986 15.3737 14.9902 15.434 14.9742C15.4654 14.9688 15.4957 14.9587 15.5241 14.9443C15.5347 14.9432 15.5449 14.9398 15.554 14.9342C15.5949 14.9175 15.6336 14.8957 15.669 14.8692L15.689 14.8542L4.17469 8.29468Z"
			fill="#28A8EA"
		/>
		<path
			d="M8.9994 12.3329V4.16696C8.99831 3.80172 8.69817 3.50158 8.33293 3.50049H5.01519V7.2282L4.17468 7.70718L4.17271 7.7082L4.16624 7.71169C4.06326 7.77118 3.99969 7.88136 3.99969 8.00012V13.0014V12.9993H8.33293C8.69817 12.9983 8.99831 12.6981 8.9994 12.3329Z"
			fill="black"
			fillOpacity="0.098039"
		/>
		<path
			d="M8.49948 12.8328V4.66684C8.49839 4.30168 8.19817 4.00153 7.833 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V13.5013V13.4993H7.833C8.19817 13.4982 8.49839 13.198 8.49948 12.8328ZM8.49948 11.8329V4.66684C8.49839 4.30168 8.19817 4.00153 7.833 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V12.5013V12.4993H7.833C8.19817 12.4983 8.49839 12.1981 8.49948 11.8329ZM7.99948 11.8329V4.66684C7.99839 4.30168 7.69824 4.00153 7.33308 4.00037H5.01519V7.22815L4.17468 7.70713L4.17271 7.70815L4.16624 7.71164C4.06326 7.77113 3.99969 7.88131 3.99969 8.00008V12.5013V12.4993H7.33308C7.69824 12.4983 7.99839 12.1981 7.99948 11.8329Z"
			fill="black"
			fillOpacity="0.2"
		/>
		<path
			d="M0.666473 3.99988H7.33251C7.69811 3.99988 7.99898 4.30068 7.99898 4.66628V11.3324C7.99898 11.698 7.69811 11.9989 7.33251 11.9989H0.666473C0.300873 11.9989 0 11.698 0 11.3324V4.66628C0 4.30068 0.300873 3.99988 0.666473 3.99988Z"
			fill="#0078D4"
		/>
		<path
			d="M1.93338 6.7337C2.11047 6.35632 2.39644 6.04047 2.75433 5.82679C3.15091 5.59974 3.60247 5.48665 4.05927 5.49981C4.48233 5.4905 4.89993 5.59777 5.26618 5.80977C5.61084 6.01501 5.88844 6.3161 6.06509 6.67625C6.25753 7.07305 6.35353 7.5097 6.34509 7.95065C6.35447 8.41152 6.25564 8.86825 6.05666 9.2841C5.87608 9.65697 5.59011 9.9689 5.23418 10.181C4.85367 10.3997 4.42051 10.5099 3.98175 10.4995C3.54953 10.5098 3.12269 10.4013 2.74786 10.186C2.40051 9.98039 2.11957 9.67901 1.93891 9.31807C1.74524 8.92694 1.64815 8.49501 1.65593 8.05865C1.64735 7.6017 1.7424 7.14876 1.93389 6.7337H1.93338ZM2.80829 8.86257C2.90277 9.10119 3.06298 9.30825 3.27033 9.45952C3.48131 9.6073 3.73426 9.68352 3.99171 9.67705C4.26604 9.68788 4.53651 9.60926 4.76218 9.45305C4.96698 9.30177 5.12298 9.09363 5.21069 8.85457C5.30931 8.5881 5.35789 8.3057 5.35418 8.02163C5.35724 7.73508 5.31157 7.44999 5.2192 7.17872C5.13775 6.9345 4.98735 6.71894 4.78618 6.55828C4.56647 6.39421 4.29673 6.31087 4.02277 6.32228C3.75971 6.31545 3.50109 6.3921 3.28429 6.54127C3.07309 6.69305 2.90931 6.90185 2.81229 7.14323C2.59775 7.69588 2.59651 8.30912 2.8088 8.86257H2.80829Z"
			fill="white"
		/>
	</svg>
);
